import { APMSubwayMap } from "@/components/apm/APMSubwayMap";
import { usePage } from "@/components/page/PageContext";
import { useAPMBlueprint } from "@/queries/apm";
import { useSessionData } from "@/stores/SessionDataContext";
import { useEffect, useMemo } from "react";

export function APMOverview() {
  const { setTitles } = usePage();
  const sessionData = useSessionData();
  const {
    data: apmData,
    isLoading,
    error,
  } = useAPMBlueprint(sessionData.code_iata);

  const customPrefix = apmData?.custom_prefix || "APM";

  useEffect(() => {
    if (apmData) {
      setTitles([`${customPrefix} Overview`]);
    } else {
      setTitles(["APM Overview"]);
    }
  }, [apmData]);

  const stations = useMemo(() => {
    if (!apmData) return [];
    return apmData.stations.map((station: any) => ({
      id: String(station.db_id),
      code: station.id,
      name: station.name,
      type: station.type as "terminal" | "concourse",
      airside: station.airside ?? true,
    }));
  }, [apmData]);

  const tracks = useMemo(() => {
    if (!apmData) return [];

    const stationCodeToDbId = new Map(
      apmData.stations.map((s: any) => [s.id, String(s.db_id)])
    );

    return apmData.tracks.map((track: any) => ({
      id: String(track.db_id),
      code: track.id,
      type: track.type as "loop" | "shuttle",
      route: track.route.map(
        (code: string) => stationCodeToDbId.get(code) || code
      ),
    }));
  }, [apmData]);

  if (isLoading) {
    return (
      <div className="w-full p-8 text-center text-muted-foreground">
        Loading {customPrefix} data...
      </div>
    );
  }

  if (error || !apmData) {
    return (
      <div className="w-full p-8 text-center text-muted-foreground">
        No {customPrefix} system configured for this airport.
      </div>
    );
  }

  return (
    <div className="w-full">
      <APMSubwayMap stations={stations} tracks={tracks} />
    </div>
  );
}
